import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
  showIcon?: boolean;
};
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  onLinkClick,
  showIcon = true,
  ...props
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center gap-2.5 rounded-lg bg-brand-coral px-6 py-3.5 text-center text-sm font-bold tracking-[0.02em] text-white shadow-soft transition-colors duration-150 hover:bg-brand-coralDark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-coral focus-visible:ring-offset-2 focus-visible:ring-offset-brand-cream sm:px-8 sm:text-base';
  const content = <>
      {showIcon && <ShoppingBagIcon size={18} strokeWidth={2.2} aria-hidden="true" className="shrink-0" data-id="element-41" data-mp="2vxxdtvnlwn1o" />}
      {children}
    </>;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      y: -2
    }} whileTap={{
      scale: 0.98
    }} data-id="element-42" data-mp="i2cysossa6lg">
        {content}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-43" data-mp="3ufuc6c8dbkx1">
      {content}
    </motion.button>;
}
export function CheckoutButton({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackCheckout} className={className} data-id="element-44" data-mp="1jouflt3h3ll4">
      {children}
    </Button>;
}